import { render, staticRenderFns } from "./StoresBasicInformation.vue?vue&type=template&id=3bfce559&scoped=true&"
import script from "./StoresBasicInformation.vue?vue&type=script&lang=js&"
export * from "./StoresBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./StoresBasicInformation.vue?vue&type=style&index=0&id=3bfce559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfce559",
  null
  
)

export default component.exports